<template>
  <div class="orderTest-container">
    <div class="title">
      cnptOS工业操作系统构成
    </div>
    <div class="box">
      <div class="item" v-for="i in list" :key="i.tit">
        <div class="tit">{{ i.tit }}</div>
        <div class="info">{{ i.info }}</div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "OS",
    components: {},
    data() {
      return {
        list: [
          {
            tit: "工业智能APP组态开发平台",
            info:
              "提供平台开放服务，发展生态合作伙伴，打造全产业链工业APP库，实现工业数据生态圈",
          },
          {
            tit: "智能服务运行管理平台",
            info:
              "提供系统公共基础服务和APP容器框架，支持服务注册、部署和管理功能",
          },
          {
            tit: "工业人工智能引擎服务",
            info:
              "通过人工智能驱动优化算法模型，实现最佳工况分析，辅助操作人员完成工艺卡边操作，提高产品质量，增强企业竞争力",
          },
          {
            tit: "工业大数据分析平台",
            info:
              "建立工业大数据平台，实现生产数据、管理数据和运营数据有效融合，打破DCS、MES、OA和ERP等业务系统的数据孤岛",
          },
          {
            tit: "工业大数据全集成平台",
            info:
              "基于工业大数据平台，提供数据分析和可视化工具集，通过拖拽式组态，实现“自助式”大数据分析和挖掘应用",
          },
          {
            tit: "工业智能APPs",
            info:
              "提供工业智能APP应用的组态开发环境，通过图形化、组件化、模块化的向导式应用构建，有效降低APP开发和设计门槛",
          },
          {
            tit: "工业互联平台",
            info:
              "提供云、企、端三层应用的统一架构，支持设备物联，私有云、公有云平台部署",
          },
        ],
      };
    },
    created() {},
    mounted() {},
    computed: {},
    watch: {},
    methods: {},
  };
</script>
<style scoped>
.orderTest-container {
  background-color: #eceef3;
  padding-bottom: 50px;
}
  .title {
    font-size: 28px;
    color: #212224;
    letter-spacing: 0;
    text-align: center;
    margin-bottom: 60px;
    padding-top: 80px;
  }
  .box {
    width: 1100px;
    margin: 0 auto;
    text-align: center;
    box-sizing: border-box;
  }
  .item {
    display: inline-block;
    width: 270px;
    height: 180px;
    margin-right: 5px;
    margin-bottom: 8px;
    text-align: left;
    padding: 25px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    box-sizing: border-box;
    overflow: hidden;
  }
  .tit {
    font-size: 18px;
    color: #212224;
    letter-spacing: 0;
    margin-bottom: 10px;
    font-weight: 550;
  }
  .info {
    font-size: 14px;
    color: #181818;
    letter-spacing: 0;
  }
</style>
